import { FC, memo, useMemo } from 'react'
import classNames from 'classnames'

type Props = {
  displayColor: string
  className?: string
  children?: React.ReactNode
}

// バッジコンポーネント
// text-smなどでバッジの全体の大きさを調整する、横幅はw-{XXX}で調整する
export const CrewBadge: FC<Props> = memo(({ ...props }) => {
  const badgeBaseClassNames = useMemo(() => {
    // ensure the width corresponds to 5 characters
    return 'crew-badge text-sm text-center w-[5rem]'
  }, [])

  return (
    <span
      className={classNames(
        badgeBaseClassNames,
        props.className,
        props.displayColor
      )}
    >
      {props.children}
    </span>
  )
})
